/*
 *
 * ExportPopUp
 *
 * @version 1.0.0
 * @author Magarelli-Fabrizio
 * @since 07-Nov-2024
 */

import ExportPopUp from './ExportPopUpContainer'

export default ExportPopUp
